import { CatItem, TraitCategory, RarityStat } from "@/types/cat";

const DATA_BASE = "/data";

/**
 * Load full cat data on the client
 */
export async function loadCats(): Promise<CatItem[]> {
  const res = await fetch(`${DATA_BASE}/cats.json`);
  if (!res.ok) throw new Error("Failed to load cats data");
  return res.json();
}

/**
 * Load trait index
 */
export async function loadTraits(): Promise<TraitCategory[]> {
  const res = await fetch(`${DATA_BASE}/traits.json`);
  if (!res.ok) throw new Error("Failed to load traits data");
  return res.json();
}

/**
 * Load search index
 */
export async function loadSearchIndex(): Promise<Array<{
  id: number;
  name: string;
  rarity: string;
  traits: CatItem["traits"];
}>> {
  const res = await fetch(`${DATA_BASE}/search-index.json`);
  if (!res.ok) throw new Error("Failed to load search index");
  return res.json();
}

/**
 * Load rarity stats
 */
export async function loadRarityStats(): Promise<RarityStat[]> {
  const res = await fetch(`${DATA_BASE}/rarity-stats.json`);
  if (!res.ok) throw new Error("Failed to load rarity stats");
  return res.json();
}
